<template>
  <v-container fluid class="secondary fill-height">
    <v-row align="center" justify="center">
      <v-col cols="6">
				<reset-password
					v-if="reset"
				>
				</reset-password>

        <change-password
					v-else
				>
				</change-password>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
	export default {
		name: "Password",

		components: {
			ResetPassword: () => import('./components/Reset.vue'),
			ChangePassword: () => import('./components/Change.vue'),
		},

		data: () => ({
			//
		}),

		computed: {
			reset() { return this.$route.query.email ? false : true }
		},

		methods: {
			//
		}
	};
</script>

<style lang="scss" scoped>
</style>